import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Terms() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    Terms & Conditions
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-8 md:p-10">

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Welcome to{" "}
                        <Link to="/" className="text-primary underline">
                            Online-Clipboard.in
                        </Link>. By accessing and using this website, you agree to comply with and be bound by the following terms and conditions. If you do not agree with any part of these terms, please do not use this service.
                    </p>

                    {/* USE */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        1. Use of Service
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        This tool is designed to provide fast and temporary text sharing between devices. You agree to use this service only for lawful purposes and in a way that does not harm the website or other users.
                    </p>

                    {/* RESPONSIBILITY */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        2. User Responsibility
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        You are fully responsible for the content you share using this platform. You must not upload or share any illegal, harmful, abusive, or sensitive information such as passwords, personal data, or confidential business information.
                    </p>

                    {/* PRIVACY */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        3. Data & Privacy
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        All shared data is stored temporarily and may be automatically deleted after a certain period or after retrieval. For detailed information, please review our{" "}
                        <Link to="/privacy-policy" className="text-primary underline">
                            Privacy Policy
                        </Link>.
                    </p>

                    {/* AVAILABILITY */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        4. Service Availability
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We strive to provide uninterrupted and reliable service. However, we do not guarantee that the website will always be available, secure, or error-free due to maintenance or technical issues.
                    </p>

                    {/* LIABILITY */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        5. Limitation of Liability
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We are not liable for any loss, damage, or issues resulting from the use of this service, including data loss or misuse caused by sharing access codes.
                    </p>

                    {/* PROHIBITED */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        6. Prohibited Uses
                    </h3>

                    <ul className="list-disc ml-6 text-textMain dark:text-textDark mb-6">
                        <li>Sharing illegal or harmful content</li>
                        <li>Attempting to misuse or hack the system</li>
                        <li>Uploading sensitive financial or personal data</li>
                    </ul>

                    {/* CHANGES */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        7. Changes to Terms
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8">
                        We may update these terms at any time without prior notice. Continued use of the website means you accept the updated terms and conditions.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}